// Steps/SegmentStep.tsx
import React from "react";
import { Field } from "formik";
import { Form } from "react-bootstrap";
import Select from "react-select";

const SEGMENTS = [
  "Accountant / Bookkeeper (serving clients)",
  "In-House Finance Team (mid-to-large company)",
  "Financial Investigator / Forensic Accountant",
  "Business Owner / Founder",
  "Lender / Underwriter / Credit Analyst",
  "Legal Professional (e.g. Family Law)",
  "Developer / Product Team (using the API)",
  "Personal Use",
  "Other",
];

export const SegmentStep: React.FC = () => {
  const segmentOptions = SEGMENTS.map((segment) => ({
    value: segment,
    label: segment,
  }));

  return (
    <div className="py-4">
      <Form.Group className="mb-4">
        <Form.Label className="h5">What best describes your role?</Form.Label>
        <Field name="segment">
          {({
            field,
            form: { touched, errors, setFieldValue, setFieldTouched },
          }) => (
            <>
              <Select
                options={segmentOptions}
                value={segmentOptions.find(
                  (option) => option.value === field.value
                )}
                onChange={(option) => {
                  setFieldValue(field.name, option?.value);
                  // Clear segment-Comment when switching away from Other
                  if (option?.value !== "Other") {
                    setFieldValue("segment-Comment", "");
                  } else {
                    setFieldTouched("segment-Comment", true);
                  }
                }}
                isClearable
                placeholder="Select your role..."
                className={`form-select-container ${
                  touched.segment && errors.segment ? "is-invalid" : ""
                }`}
                classNamePrefix="form-select"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor:
                      touched.segment && errors.segment
                        ? "#dc3545"
                        : base.borderColor,
                    padding: "4px",
                    fontSize: "16px",
                  }),
                }}
              />
              {touched.segment && errors.segment && (
                <div className="invalid-feedback d-block">{errors.segment}</div>
              )}

              {field.value === "Other" && (
                <Field name="segment-Comment">
                  {({
                    field: commentField,
                    form: { touched, errors, setFieldTouched },
                  }) => (
                    <>
                      <Form.Control
                        {...commentField}
                        type="text"
                        placeholder="Please specify your role"
                        className={`mt-3 ${
                          touched["segment-Comment"] &&
                          errors["segment-Comment"]
                            ? "is-invalid"
                            : ""
                        }`}
                        onBlur={() => setFieldTouched("segment-Comment", true)}
                      />
                      {touched["segment-Comment"] &&
                        errors["segment-Comment"] && (
                          <div className="invalid-feedback d-block">
                            {errors["segment-Comment"]}
                          </div>
                        )}
                    </>
                  )}
                </Field>
              )}
            </>
          )}
        </Field>
      </Form.Group>
    </div>
  );
};
